export default __webpack_public_path__ + "352c1edb132ab34a14a473444cc57bc6.png";